import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Loader from '../Loader';
import { Helmet } from 'react-helmet';

import '../../assets/css/Antenne/Antenne.css';
import "../../assets/css/NotFound.css";
import { API_BASE_URL } from '../../utils/config';

import AntenneContact from './Antenne_Contact';
import AntenneService from './Antenne_Service';
import AntenneBlog from './Antenne_Blog';

function AntenneDetail() {
    const { id } = useParams();
    const [antenne, setAntenne] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        fetch(`${API_BASE_URL}/antennes/${id}`)
            .then((response) => response.json())
            .then((data) => {
                setAntenne(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération de l'antenne :", error);
                setIsLoading(false);
            });
    }, [id]);

    if (isLoading) {
        return <Loader />;
    }

    if (!antenne || antenne.error) {
        return (
            <div className="not-found-container">
                <p>Erreur : L'antenne demandée n'existe pas.</p>
                <Link to="/" className="back-home">Retour à l'accueil</Link>
            </div>
        );
    }

    return (
        <div className="antenne-detail container">
            <Helmet>
                <title>{`Secouristes Français Croix Blanche | ${antenne.nom || id}`}</title>
                <link rel="canonical" href={`https://croixblanche-42.org/antenne/${id}`} />
            </Helmet>

            {/* Section du contact */}
            <AntenneContact antenne={antenne} />

            {/* Section des services */}
            <AntenneService services={antenne.services || []} />
            
            {/* Section Blog */}
            <AntenneBlog antenneId={id} />
        </div>
    );
}

export default AntenneDetail;
